import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError.ts';
import { EICFTemplatesApi } from '../../../apis/EICFApi/EICFTemplatesApi.ts';

interface PutAllowedSignersVars {
    facilityId: number;
    hcpIds: number[];
}

export function usePutAllowedSignersForFacility() {
    const queryClient = useQueryClient();
    const { t } = useTranslation();
    return useMutation<void, AppMedError, PutAllowedSignersVars>({
        mutationKey: [QueryKeys.eicfAllowedSigners, 'put'],
        mutationFn: ({ facilityId, hcpIds }) =>
            EICFTemplatesApi.setAllowedSigners(facilityId, hcpIds),
        onSuccess: (_data, vars) => {
            queryClient.invalidateQueries({
                queryKey: [QueryKeys.eicfAllowedSigners, vars.facilityId],
            });
            queryClient.invalidateQueries({ queryKey: [QueryKeys.eicfCanSign] });
            notifications.show({
                color: 'green',
                message: t('eicf.admin.allowedSignersSaved'),
            });
        },
        onError: (err) => {
            notifications.show({ color: 'red', message: err.message });
        },
    });
}
